export default "__VITE_ASSET__35e82202__"